import { Component, OnInit, ViewChild } from '@angular/core';
import { CertificateRequestFormComponent } from './certificate-request-form/certificate-request-form.component';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.css']
})
export class AdminComponent implements OnInit {

  resetAvailable = false;

  constructor() { }

  @ViewChild(CertificateRequestFormComponent) form: CertificateRequestFormComponent;

  ngOnInit(): void {
  }

  resetForm() {
    if (this.form !== undefined) {
      this.form.reset();
    }
  }
}
